// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_enum-bug-keys.js
// module id = 148
// module chunks = 168707334958949